import store from "../../../../store";
import { FNO_BAN, FNO_BAN_CLEAR_MSG, FNO_BAN_ERROR, FNO_BAN_HIDE_ERROR, FNO_BAN_MSG, FNO_BAN_START_LOADER, FNO_BAN_STOP_LOADER, } from "../interface/iFnoBan";
var FnoBanActions = /** @class */ (function () {
    function FnoBanActions() {
        this.dispatch = store.dispatch;
    }
    FnoBanActions.prototype.setFnoBanMsg = function (message, type, reducerName) {
        this.dispatch({
            type: FNO_BAN_MSG,
            payload: { message: message },
            errorMsg: type,
            reducerName: reducerName,
        });
    };
    FnoBanActions.prototype.clearFnoBanMsg = function (type, reducerName) {
        this.dispatch({
            type: FNO_BAN_CLEAR_MSG,
            errorMsg: type,
            reducerName: reducerName,
        });
    };
    FnoBanActions.prototype.getFnoBanData = function (data, reducerName) {
        this.dispatch({
            type: FNO_BAN,
            payload: { data: data },
            reducerName: reducerName,
        });
    };
    FnoBanActions.prototype.setError = function (payload, reducerName) {
        this.dispatch({
            type: FNO_BAN_ERROR,
            payload: { errorData: payload },
            reducerName: reducerName,
        });
    };
    FnoBanActions.prototype.hideError = function (reducerName) {
        this.dispatch({
            type: FNO_BAN_HIDE_ERROR,
            reducerName: reducerName,
        });
    };
    FnoBanActions.prototype.startFnoBanloader = function (reducerName) {
        this.dispatch({
            type: FNO_BAN_START_LOADER,
            reducerName: reducerName,
        });
    };
    FnoBanActions.prototype.stopFnoBanLoader = function (reducerName) {
        this.dispatch({
            type: FNO_BAN_STOP_LOADER,
            reducerName: reducerName,
        });
    };
    return FnoBanActions;
}());
export default FnoBanActions;
